import ReactGA from 'react-ga';
import { Component } from 'react';
import { Provider } from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import { RawIntlProvider } from 'react-intl';
import { createMuiTheme } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { StylesProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'moment/locale/es';

import Routing from '../routing';
import { TanStackQueryProvider } from 'tools/tan-stack-query';
import { muiTypographyProps, muiThemeTypography } from '../common/typography';
import { StatsigInitialization } from 'tools/statsig/statsigInitialization';
import { BlockNotifyMobileDevices } from 'features/block-notify-mobile-devices';

import { initializeIntl } from '../../intl/intl';
import appStore from '../../redux/stores/app.store';
import AppActions from '../../redux/actions/app-actions';
import LocalStorageService from '../../services/local-storage-service';

import { red, neutral, teal } from '../../shared/styles/colors';
import '../../assets/styles/styles.css';
import '../../assets/styles/fonts.css';
import messages_es from '../../assets/i18n/es.json';
import messages_pt from '../../assets/i18n/pt.json';

ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID, {
  debug: process.env.REACT_APP_GA_DEBUG_ENABLED === 'true',
  titleCase: false,
});

const messages = {
  es: messages_es,
  pt: messages_pt,
};

const defaultLanguage = 'es';
const storedLanguage = LocalStorageService.getLanguage();
const navigatorLanguage = navigator.language.substring(0, 2);

let language = defaultLanguage;

if (storedLanguage) {
  language = storedLanguage;
} else if (messages.hasOwnProperty(navigatorLanguage)) {
  language = navigatorLanguage;
}
appStore.store.dispatch(AppActions.setLanguageAction(language));
LocalStorageService.setLanguage(language);

const intl = initializeIntl(language, messages);

export const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    text: {
      primary: neutral.black,
      secondary: neutral.D15,
    },
    primary: {
      contrastText: neutral.white,
      main: teal.D5,
    },
    secondary: {
      contrastText: neutral.white,
      main: red.D10,
    },
    background: {
      default: neutral.white,
    },
    tertiary: {
      contrastText: neutral.white,
      main: neutral.D10,
    },
  },
  typography: muiThemeTypography,
  props: {
    MuiTypography: muiTypographyProps,
  },
});

class App extends Component {
  render() {
    return (
      <Provider store={appStore.store}>
        <RawIntlProvider value={intl}>
          <CssBaseline>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <ThemeProvider theme={theme}>
                <StylesProvider injectFirst>
                  <TanStackQueryProvider>
                    <BlockNotifyMobileDevices>
                      <StatsigInitialization>
                        <Routing />
                      </StatsigInitialization>
                    </BlockNotifyMobileDevices>
                  </TanStackQueryProvider>
                </StylesProvider>
              </ThemeProvider>
            </MuiPickersUtilsProvider>
          </CssBaseline>
        </RawIntlProvider>
      </Provider>
    );
  }
}

export default App;
